import React from 'react';
import { SiteHeader } from '../components/SiteHeader';
import { Hero } from '../components/Hero';
import { OrderBuilder } from '../components/OrderBuilder/OrderBuilder';
import { ProblemSection } from '../components/ProblemSection';
import { DoorsSection } from '../components/DoorsSection';
import { BenefitsSection } from '../components/BenefitsSection';
import { TrustSection } from '../components/TrustSection';
import { LeadForm } from '../components/LeadForm';
import { UrgencySection } from '../components/UrgencySection';
import { DistributorSection } from '../components/DistributorSection';
import { FaqSection } from '../components/FaqSection';
import { FinalCta } from '../components/FinalCta';
import { SiteFooter } from '../components/SiteFooter';
import { FloatingWhatsApp } from '../components/FloatingWhatsApp';
export function Landing() {
  return <div className="min-h-screen w-full bg-white" data-id="element-322" data-mp="h6e7v2q1jg1r">
      <SiteHeader data-id="element-323" data-mp="m6scsbwci9vk" />
      <main data-id="element-324" data-mp="m8d843qhhwuh">
        <Hero data-id="element-325" data-mp="m7v42kxkyec0" />
        <OrderBuilder data-id="element-326" data-mp="m58z8t22qcxh" />
        <ProblemSection data-id="element-327" data-mp="29sa8nqqxx0a" />
        <DoorsSection data-id="element-328" data-mp="2b3a4ch2mkm4" />
        <BenefitsSection data-id="element-329" data-mp="2blddt25hz3j" />
        <TrustSection data-id="element-330" data-mp="27nw7cz4vhma" />
        <LeadForm data-id="element-331" data-mp="3tftnn2y6p2p3" />
        <UrgencySection data-id="element-332" data-mp="3tfa3dfl2a27w" />
        <DistributorSection data-id="element-333" data-mp="3tes2g5ngeztn" />
        <FaqSection data-id="element-334" data-mp="3peq7sgg4z6nv" />
        <FinalCta data-id="element-335" data-mp="3pe81eqzrfc28" />
      </main>
      <SiteFooter data-id="element-336" data-mp="3pfj6qv8usrvg" />
      <FloatingWhatsApp data-id="element-337" data-mp="3pezyy7cx3jv5" />
    </div>;
}